import React, { useContext } from 'react';

export interface ShopsConfig {
	shopParentModelCode: string;
	useEmail?: boolean;
	useCategories?: boolean;
	useGhosts?: boolean;
	useTags?: boolean;
	useCustomAudienceDefinition?: boolean;
	showLastUpdateDateFromApp?: boolean;
}

export const DefaultShopsConfig: ShopsConfig = {
	shopParentModelCode: 'SECTOR',
	useEmail: false,
	useCategories: false,
	useGhosts: true,
	useTags: true,
	useCustomAudienceDefinition: false,
	showLastUpdateDateFromApp: false,
};

export const ShopsContext = React.createContext<ShopsConfig>(DefaultShopsConfig);
export const useShopsConfig = (): ShopsConfig => useContext<ShopsConfig>(ShopsContext);
